import React, { Fragment } from 'react';
import * as PropTypes from 'prop-types';

import MeetingNote from './meeting-notes-list-item';
import { AddButton, DividerS, Placeholder } from './styles';

const NotesList = ({
  notes,
  requestId,
  onNoteCreate,
  ...rest
}) => (
  <Fragment>
    <AddButton onClick={() => onNoteCreate(requestId)}>
      <b>+</b> Add notes
    </AddButton>
    <DividerS />
    {!notes.length && <Placeholder>No notes yet...</Placeholder>}
    {notes.map((note, index) =>
      (<Fragment key={note._id}>
        <MeetingNote
          {...rest}
          {...note}
          number={index + 1}
          requestId={requestId}
        />
        {index < notes.length - 1 && <DividerS />}
      </Fragment>))}
  </Fragment>
);

NotesList.propTypes = {
  notes: PropTypes.array,
  requestId: PropTypes.string.isRequired,
  onNoteCreate: PropTypes.func.isRequired,
};

NotesList.defaultProps = {
  notes: [],
};

export default NotesList;



// WEBPACK FOOTER //
// ./src/components/notes-simple-list/index.js